
<template>
  <b-card no-body >
    <b-card-body>
      <div class="d-flex justify-content-between  flex-wrap">
        <!-- Registar Tipo  -->
        <b-form-group
            label-for="filterInput"
            class="mb-0"
        >
          <b-button
              variant="gradient-primary"
              size="sm"
              class="mr-1"
              @click="traerEmpresas"
          >
            <feather-icon
                icon="RefreshCwIcon"
            />
          </b-button>
          <b-button
              variant="gradient-primary"
              size="sm"
              @click="mostrarModal(1, 0, '','')"
          >
            <feather-icon
                icon="PlusIcon"
                class="mr-50"
            />
            <span class="align-middle">Registrar Versión</span>
          </b-button>
        </b-form-group>

        <!-- filter -->
        <b-form-group
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Buscar"
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Borrar
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

      </div>
    </b-card-body>

    <b-table
        hover
        responsive
        class="position-relative"
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="cPaginacion"
    >
      <template #cell(estado)="data">
        <b-badge :variant="status[1][data.value]">
          {{ status[0][data.value] }}
        </b-badge>
      </template>

      <template #cell(acciones)="data">
        <div class="text-nowrap">
          <feather-icon
              :id="`btn_${data.item.id}_editar`"
              icon="EditIcon"
              size="16"
              class="mx-1"
              @click="mostrarModal(2, data.item.id, data.item.nombre,data.item.nombre_corto, data.item.estado)"
          />
          <b-tooltip
              title="Editar registro"
              :target="`btn_${data.item.id}_editar`"
          />
          <feather-icon
              :id="`btn_${data.item.id}_eliminar`"
              icon="Trash2Icon"
              size="16"
              @click="eliminarRegistro(data.item.id, data.item.nombre)"
          />
          <b-tooltip
              title="Eliminar registro"
              :target="`btn_${data.item.id}_eliminar`"
          />
        </div>
      </template>
    </b-table>

    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <!-- page length -->
      <b-form-group
          label="Mostrar"
          label-cols="5"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
            id="perPageSelect2"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
        />

      </b-form-group>

      <!-- pagination -->
      <div>
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
        >
          <template #prev-text>
            <feather-icon
                icon="ChevronLeftIcon"
                size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
                icon="ChevronRightIcon"
                size="18"
            />
          </template>
        </b-pagination>
      </div>
    </b-card-body>

    <b-modal
        id="modalRegistro"
        v-model="estadoModal"
        :title="infoModal.title"
        :ok-title="infoModal.boton"
        cancel-variant="outline-secondary"
        cancel-title="Cancelar"
        @hidden="resetModal"
        @ok="okModal"
        centered
    >
      <form
          ref="form"
          @submit.stop.prevent="enviarFormulario"
      >
        <b-row>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Nombre"
                label-for="nombre"
                invalid-feedback="Nombre es requerido"
            >
              <b-form-input
                  id="nombre"
                  placeholder="Nombre"
                  v-model="nombre"
                  :state="validacion"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                :state="validacion"
                label="Nombre Corto"
                label-for="nombre_corto"
                invalid-feedback="Nombre Corto es requerido"
            >
              <b-form-input
                  id="nombre_corto"
                  placeholder="Nombre Corto"
                  v-model="nombre_corto"
                  :state="validacion"
                  required
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="Estado"
                label-for="estado"
                invalid-feedback="Estado es requerido"
            >
              <v-select
                  id="estado"
                  v-model="estado"
                  label="text"
                  :options="estados"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </b-card>
</template>

<script>
import axiosIns from '../../../libs/axios'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import {
  BCard,
  BTable,
  BAvatar,
  BBadge,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCardBody,
  BTooltip,
  BModal,
  VBModal,
  BListGroup,
  BListGroupItem,
  BRow,
  BCol
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BCardBody,
    BTooltip,
    BModal,
    VBModal,
    BListGroup,
    BListGroupItem,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [5, 10, 15],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      estadoModal: false,
      infoModal: {
        title: '',
        boton: '',
      },
      fields: [
        {
          key: 'nombre',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'nombre_corto',
          label: 'Nombre corto',
          sortable: true
        },
        {
          key: 'estado',
          label: 'Estado',
          sortable: true
        },
        {
          key: 'acciones'
        },
      ],
      items: [],
      status: [
        {
          1: 'Activo',
          0: 'Inactivo',
        },
        {
          1: 'light-success',
          0: 'light-danger',
        }
      ],
      validacion: null,
      estados: [
        {value: 1, text: "Activo"},
        {value: 0, text: "Inactivo"}
      ],
      nombre: '',
      estado: {value: 1, text: "Activo"},
      id: 0,
      tipo: 0,
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => ({
            text: f.label,
            value: f.key
          }))
    },
  },
  mounted() {
    this.traerEmpresas();
  },
  methods: {
    traerEmpresas(){
      var yo = this

      var config = {
        method: 'get',
        url: '/forecast/forecast/versiones/'
      };

      axiosIns(config)
          .then(function (response) {
            yo.items = response.data;
            yo.totalRows = yo.items.length
          })
          .catch(function (error) {
            console.log(error);
          });
    },

    cPaginacion(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    mostrarModal(tipo, id, nombre,nombre_corto, estado){
      this.tipo = tipo
      this.estadoModal = true

      if (this.tipo === 1 ){
        this.infoModal.title = 'Registrar Versión'
        this.infoModal.boton = 'Registar'
      }
      else if (this.tipo === 2 ){
        this.infoModal.title = 'Editar Versión'
        this.infoModal.boton = 'Editar'

        this.id = id
        this.nombre = nombre
        this.nombre_corto = nombre_corto

        this.estado = {value: parseInt(estado), text: estado === '1' ? 'Activo' : 'Inactivo'}
      }
    },

    mostrarNotificacion(titulo, icono, texto, variante){
      this.$toast({
            component: ToastificationContent,
            props:{
              title: titulo,
              icon: icono,
              text: texto,
              variant: variante
            }
          },
          {
            timeout: 5000
          })
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.boton = ''
      this.estadoModal = false
    },

    validarFormulario() {
      const valid = this.$refs.form.checkValidity()
      this.validacion = valid
      return valid
    },

    resetModal() {
      this.codigo = ''
      this.descrip = ''
      this.nombre = ''
      this.nombre_corto = ''
      this.estado = {value: 1, text: "Activo"}
      this.validacion = null
      this.resetInfoModal()
    },

    okModal(bvModalEvt) {

      bvModalEvt.preventDefault()

      this.enviarFormulario()
    },

    enviarFormulario() {
      // Exit when the form isn't valid
      if (!this.validarFormulario()) {
        return
      }

      // Hide the modal manually
      this.$nextTick(() => {
        var yo = this

        var data = JSON.stringify({
          "nombre": yo.nombre.toUpperCase(),
          "nombre_corto": yo.nombre_corto.toUpperCase(),
          "estado": yo.estado.value.toString()
        });


        var url = this.tipo === 1 ? '/forecast/forecast/versiones/crear/' : '/forecast/forecast/versiones/editar/'+this.id
        var metodo = this.tipo === 1 ? 'post' : 'patch'

        var config = {
          method: metodo,
          url: url,
          headers: {
            'Content-Type': 'application/json'
          },
          data : data
        };

        axiosIns(config)
            .then(function (response) {

              if (response.status === 201 || response.status === 200){
                yo.traerEmpresas();

                if (yo.tipo === 1){
                  yo.mostrarNotificacion('Registro creado', 'CheckIcon', 'La Versión ' +'' + ' ha sido registrado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Registro modificado', 'CheckIcon', 'La Versión ' + yo.nombre + ' ha sido modificado correctamente', 'success')
                }

              }else{
                yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
              }

            })
            .catch(function (error) {
              console.log(error);
              yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
            });

        this.estadoModal = false
      })
    },

    eliminarRegistro(id, empresa){
      var yo = this

      this.$swal({
        title: '¡Alerta!',
        text: "¿Seguro que quieres eliminar la versión " + empresa + "?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true,
        customClass: {
          confirmButton: 'btn btn-primary ml-1',
          cancelButton: 'btn btn-outline-danger',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          var config = {
            method: 'delete',
            url: '/forecast/forecast/versiones/eliminar/' + id,
            headers: { }
          };

          axiosIns(config)
              .then(function (response) {
                if (response.status === 204){
                  yo.traerEmpresas();
                  yo.mostrarNotificacion('Registro eliminado', 'CheckIcon', 'La versión ha sido eliminado correctamente', 'success')
                }else{
                  yo.mostrarNotificacion('Error', 'BellIcon', JSON.stringify(response.data).toString(), 'danger')
                }
              })
              .catch(function (error) {
                yo.mostrarNotificacion('Error en el registro', 'BellIcon', error.toString(), 'danger')
              });
        }
      })
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
